module.exports = __webpack_public_path__ + "static/media/five.26a88760.svg";